import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledInvoiceSnippet = styled.div`
  ${bordersStyles.default};
  
  align-items: center;
  display: flex;
  flex-direction: row;
  
  padding: 12px 24px;
  
  a {
    margin-left: auto;
    
    svg {
      height: 24px;
      width: 24px;
    }
  }

  .placeholder {
    height: 42px;
    width: 42px;
  }
`;

const StyledInvoiceSnippetContent = styled.div`
  ${typographyStyles.footnote.description};
  margin-left: 10px;
  
  & * {
    ${typographyStyles.footnote.description};
  }
  
  .invoice-status-mark {
    & > div {
      height: 20px;
    }
  }
  
  .amount {
    font-weight: 500;
  }
`;

const StyledInvoiceSnippetContentTitle = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.neutral_8};
  display: flex;
  
  .amount {
    color: ${props => props.theme.colors.functional_danger};
    display: inline-flex;
    margin-left: 10px;
  }
  
  & * {
    color: ${props => props.danger ? props.theme.colors.functional_danger : props.theme.colors.neutral_8};
  }
`;

const StyledInvoiceSnippetContentValue = styled.div`
  color: ${props => props.theme.colors.neutral_10};
`;


export {
  StyledInvoiceSnippet,
  StyledInvoiceSnippetContent,
  StyledInvoiceSnippetContentTitle,
  StyledInvoiceSnippetContentValue,
}